import { Component, OnDestroy, OnInit } from '@angular/core';
import { MenuComponent } from './menu/menu.component';
import { Router } from '@angular/router';
import { ClipboardModule } from '@angular/cdk/clipboard';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { MCButtonComponent } from '@maslul/common-components';

@Component({
    selector: 'mi-app-header',
    imports: [MenuComponent,
        ClipboardModule,
        MCButtonComponent
    ],
    templateUrl: './header.html',
    styleUrl: './header.scss'
})
export class HeaderComponent implements OnInit, OnDestroy {

  isOpenLanguage: boolean = false;
  commonText: any;
  subscribtion: Subscription = new Subscription();

  constructor(private router: Router
    , private translateService: TranslateService
  ) {

  }

  ngOnDestroy(): void {
    this.subscribtion.unsubscribe();
  }

  ngOnInit(): void {
    this.initText();
  }

  goToHome() {
    this.router.navigate(['']);
  }

  toggleLanguage() {
    this.isOpenLanguage = !this.isOpenLanguage;
  }

  initText() {

    this.subscribtion.add(this.translateService.stream('common').subscribe(translation => {
      this.commonText = translation;
    }));

  }

  textToCopy: string = 'הטקסט הסודי שאני רוצה להעתיק כעת.';

  // 2. משתנה לשליטה בהודעת הפידבק
  isCopied: boolean = false;
  private feedbackTimeout: any;

  // 3. הפונקציה המופעלת בלחיצה
  onCopy(): void {
    // הדירקטיבה cdkCopyToClipboard מטפלת בפועל בהעתקה.
    // פונקציה זו משמשת רק להצגת פידבק למשתמש.

    this.isCopied = true;

    // נקה כל טיימר קודם כדי למנוע הצפת הודעות
    if (this.feedbackTimeout) {
      clearTimeout(this.feedbackTimeout);
    }

    // הסתר את הודעת הפידבק לאחר 2 שניות
    this.feedbackTimeout = setTimeout(() => {
      this.isCopied = false;
    }, 2000);
  }
}
